// Handle linked embroidery item removal
// When embroidery fee is removed, also remove the main product

class EmbroideryCartLinker {
  constructor() {
    this.processing = false;
    this.init();
  }

  init() {
    // Use MutationObserver to watch for cart changes
    this.observeCartChanges();
    
    // Also hook into remove button clicks directly
    this.hookRemoveButtons();
  }

  observeCartChanges() {
    // Watch for cart drawer updates
    const observer = new MutationObserver(() => {
      this.hookRemoveButtons();
    });

    // Start observing the cart drawer
    const cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer) {
      observer.observe(cartDrawer, {
        childList: true,
        subtree: true
      });
    }

    // Also watch main cart page
    const mainCart = document.querySelector('cart-items');
    if (mainCart) {
      observer.observe(mainCart, {
        childList: true,
        subtree: true
      });
    }
  }

  hookRemoveButtons() {
    // Find all cart remove buttons
    const removeButtons = document.querySelectorAll('cart-remove-button, .cart-remove-button, [data-index]');
    
    removeButtons.forEach(button => {
      if (button.dataset.embroideryLinked) return; // Already hooked
      
      button.dataset.embroideryLinked = 'true';
      button.addEventListener('click', async (e) => {
        await this.handleRemoveClick(e, button);
      });
    });
  }

  async handleRemoveClick(event, button) {
    if (this.processing) return;
    
    try {
      // Get the line index from the button
      const lineIndex = parseInt(button.dataset.index);
      if (!lineIndex) return;

      // Get current cart
      const cartResponse = await fetch('/cart.js');
      const cart = await cartResponse.json();
      
      // Get the item being removed
      const removedItem = cart.items[lineIndex - 1]; // line is 1-indexed
      
      if (!removedItem || !removedItem.properties) return;
      
      console.log('🔍 Checking item for embroidery link:', removedItem);
      
      // Check if this is an embroidery fee item
      const isEmbroideryFee = removedItem.properties._is_embroidery_fee === 'true';
      
      if (isEmbroideryFee) {
        // Prevent default removal for now
        event.preventDefault();
        event.stopImmediatePropagation();
        
        this.processing = true;
        
        const embroideryGroup = removedItem.properties._embroidery_group;
        console.log('🎨 Embroidery fee detected, finding linked product with group:', embroideryGroup);
        
        // Find the linked main product
        const linkedItemIndex = cart.items.findIndex((item, index) => {
          return index !== (lineIndex - 1) && // Don't match itself
                 item.properties &&
                 item.properties._embroidery_group === embroideryGroup &&
                 item.properties._is_embroidery_fee !== 'true'; // Find the main product
        });
        
        if (linkedItemIndex !== -1) {
          const linkedLine = linkedItemIndex + 1;
          console.log('🔗 Found linked product at line:', linkedLine);
          
          // Remove both items
          try {
            // Remove the main product first
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: linkedLine,
                quantity: 0,
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
              })
            });
            
            console.log('✅ Linked product removed');
            
            // Then remove the embroidery fee
            const response = await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({
                line: lineIndex,
                quantity: 0,
                sections: ['cart-drawer', 'cart-icon-bubble'],
                sections_url: window.location.pathname
              })
            });
            
            const result = await response.json();
            console.log('✅ Embroidery fee removed');
            
            // Refresh the cart display
            const cartDrawerItems = document.querySelector('cart-drawer-items');
            if (cartDrawerItems && typeof cartDrawerItems.onCartUpdate === 'function') {
              cartDrawerItems.onCartUpdate();
            } else {
              // Force reload cart sections
              window.location.reload();
            }
            
          } catch (error) {
            console.error('Error removing linked items:', error);
          } finally {
            this.processing = false;
          }
        } else {
          // No linked product found, just proceed with normal removal
          this.processing = false;
        }
      }
    } catch (error) {
      console.error('Error in handleRemoveClick:', error);
      this.processing = false;
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new EmbroideryCartLinker();
  });
} else {
  new EmbroideryCartLinker();
}

